import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { isMobileContext } from "../context/isMobileContext";
import { motion } from "framer-motion";

export default function Statement({ data, secondStatement }) {
	const { t } = useTranslation();
	const { isMobile } = useContext(isMobileContext);
	return (
		<div
			className={`statement-section ${
				secondStatement ? "secondStatement" : ""
			}`}
		>
			{isMobile && (
				<div className="mobile-header">
					<h3 className="headline">
						<div className="chairmen-container">
							<motion.h3
								initial={{ opacity: 0, translateY: "100%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{ ease: "easeInOut", delay: 0, duration: 0.5 }}
								className="chairman"
							>
								{data.position}
							</motion.h3>
						</div>
						<div className="statement-container">
							<motion.h3
								initial={{ opacity: 0, translateY: "100%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{ ease: "easeInOut", delay: 0.3, duration: 0.5 }}
							>
								{data.statement_word}
							</motion.h3>
						</div>
					</h3>
				</div>
			)}
			<motion.div
				initial={{ opacity: 0 }}
				whileInView={{ opacity: 1 }}
				viewport={{ once: true }}
				transition={{ ease: "easeInOut", delay: 0.5, duration: 0.7 }}
				className="img-container"
			>
				<img
					src={isMobile ? process.env.PUBLIC_URL + data.img_mobile : process.env.PUBLIC_URL + data.img_desktop}
					alt="chairman_img"
				/>
			</motion.div>
			<div className="info">
				{!isMobile && (
					<>
						<div className="headline-container">
							<h3 className="headline">
								<div className="chairmen-container">
									<motion.h3
										initial={{ opacity: 0, translateY: "100%" }}
										whileInView={{ opacity: 1, translateY: 0 }}
										viewport={{ once: true }}
										transition={{ ease: "easeInOut", delay: 0, duration: 0.5 }}
										className="chairman"
									>
										{data.position}
									</motion.h3>
								</div>
								<div className="statement-container">
									<motion.h3
										initial={{ opacity: 0, translateY: "100%" }}
										whileInView={{ opacity: 1, translateY: 0 }}
										viewport={{ once: true }}
										transition={{
											ease: "easeInOut",
											delay: 0.2,
											duration: 0.5,
										}}
									>
										{data.statement_word}
									</motion.h3>
								</div>
							</h3>
						</div>
					</>
				)}
				<motion.span
					initial={{ opacity: 0 }}
					whileInView={{ opacity: 1 }}
					viewport={{ once: true }}
					transition={{
						ease: "easeInOut",
						delay: isMobile ? 0.2 : 0.35,
						duration: 0.5,
					}}
					className="sub-headline"
				>
					{data.sub_headline}
				</motion.span>
				{!isMobile && 
					<div className={`desc`}>
						{data.paragraphs.map((para, index) => (
							<motion.p
								initial={{ opacity: 0 }}
								whileInView={{ opacity: 1 }}
								viewport={{ once: true }}
								transition={{
									ease: "easeInOut",
									delay: isMobile
										? 0.3 + parseFloat(index * 0.05)
										: 0.5 + parseFloat(index * 0.055),
									duration: 0.5,
								}}
								className={`para`}
							>
								{para}
							</motion.p>
						))}
					</div>
				}
				{isMobile &&
				<div className={`desc`}>
					{data.paragraphsMobile.map((para, index) => (
						<motion.p
							initial={{ opacity: 0 }}
							whileInView={{ opacity: 1 }}
							viewport={{ once: true }}
							transition={{
								ease: "easeInOut",
								delay: isMobile
									? 0.3 + parseFloat(index * 0.05)
									: 0.5 + parseFloat(index * 0.055),
								duration: 0.5,
							}}
							className={`para`}
						>
							{para}
						</motion.p>
					))}
				</div>
				}
				<div className="credentials">
					<motion.h4
						initial={{ opacity: 0 }}
						whileInView={{ opacity: 1 }}
						viewport={{ once: true }}
						transition={{
							ease: "easeInOut",
							delay: isMobile ? 0.6 : 0.8,
							duration: 0.5,
						}}
						className="hh"
					>
						{data.his_highness}
					</motion.h4>
					<motion.h3
						initial={{ opacity: 0 }}
						whileInView={{ opacity: 1 }}
						viewport={{ once: true }}
						transition={{
							ease: "easeInOut",
							delay: isMobile ? 0.8 : 1,
							duration: 0.6,
						}}
						className="name"
					>
						{data.name}
					</motion.h3>
					<motion.h4
						initial={{ opacity: 0 }}
						whileInView={{ opacity: 1 }}
						viewport={{ once: true }}
						transition={{
							ease: "easeInOut",
							delay: isMobile ? 1 : 1.2,
							duration: 0.6,
						}}
						className="title"
					>
						{data.title}
					</motion.h4>
				</div>
			</div>
			{!secondStatement && !isMobile && (
				<div className="back-layer1">
					<img
						src={process.env.PUBLIC_URL + "/imgs/home-page/statement-back-layer1.svg"}
						alt="back-layer"
					/>
				</div>
			)}
			{/* {!secondStatement && !isMobile && (
				<div className="back-layer2">
					<img
						src={process.env.PUBLIC_URL + "/imgs/home-page/statement-back-layer2.svg"}
						alt="back-layer"
					/>
				</div>
			)} */}
			{secondStatement && !isMobile && (
				<div className="back-layer3">
					<img
						src={process.env.PUBLIC_URL + "/imgs/home-page/statement-back-layer3.svg"}
						alt="back-layer"
					/>
				</div>
			)}
			{/* {secondStatement && !isMobile && (
				<div className="back-layer4">
					<img
						src={process.env.PUBLIC_URL + "/imgs/home-page/statement-back-layer4.svg"}
						alt="back-layer"
					/>
				</div>
			)} */}
			{isMobile && (
				<div className="back-layer1-mobile">
					<img
						src={process.env.PUBLIC_URL + "/imgs/home-page/vector-bg.png"}
						alt="back-layer"
					/>
				</div>
			)}
			{isMobile && (
				<div className="back-layer2-mobile">
					<img
						src={process.env.PUBLIC_URL + "/imgs/home-page/Subtract.png"}
						alt="back-layer"
					/>
				</div>
			)}
		</div>
	);
}
